import { api } from '@/lib/api'

export function downloadAccountStatements({ id }: { id: string }) {
  return api.get<BlobPart>(`/v1/me/statements/${id}/download`, {
    responseType: 'blob',
  })
}
